import moment from 'moment-timezone';

export const TIMEZONES = moment.tz.names().map((name) => ({
    label: name,
    value: moment().tz(name).format('ZZ')
}));
